import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';

export const StyledBodyCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.body}`]: {
        wordBreak: 'break-all',
        fontSize: 12,
        padding: 10,
    },
}));
